import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'

const routes = [
    // Front-end
    { path: '/', component: () => import('@/views/Index.vue') },
    { path: '/about', component: () => import('@/views/About.vue') },
    { path: '/news', component: () => import('@/views/News.vue') },
    {
        path: '/news/:id',
        name: 'NewsDetail',
        component: () => import('@/views/NewsDetail.vue')
    },
    {
        path: '/patents',
        name: 'Patents',
        component: () => import('@/views/Patents.vue')
    },
    { path: '/products', component: () => import('@/views/Products.vue') },
    { path: '/products/:categoryId', component: () => import('@/views/ProductCategory.vue') },
    { path: '/products/:categoryId/:subCategoryId', component: () => import('@/views/ProductList.vue') },
    { path: '/products/detail/:productId', component: () => import('@/views/ProductDetail.vue') },
    { path: '/support', component: () => import('@/views/Support.vue') },
    { path: '/contact', component: () => import('@/views/Contact.vue') },

    // Admin
    { path: '/admin/login', component: () => import('@/views/admin/AdminLogin.vue') },
    { path: '/admin/register', component: () => import('@/views/admin/AdminRegister.vue') },
    {
        path: '/admin',
        redirect: '/admin/dashboard',
        component: () => import('@/layout/AdminLayout.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
        children: [
            { path: 'dashboard', component: () => import('@/views/admin/AdminDashboard.vue') },
            { path: 'news', component: () => import('@/views/admin/AdminNews.vue') },
            { path: 'products/categories', component: () => import('@/views/admin/AdminCategories.vue') },
            { path: 'products/subcategories', component: () => import('@/views/admin/AdminSubcategories.vue') },
            { path: 'products', component: () => import('@/views/admin/AdminProducts.vue') },
            { path: 'contacts', component: () => import('@/views/admin/AdminContacts.vue') },
            { path: 'patents', component: () => import('@/views/admin/AdminPatents.vue') }
        ]
    },

    // 404
    { path: '/:pathMatch(.*)*', component: () => import('@/views/NotFound.vue') }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(_to, _from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    }
})

router.beforeEach(async (to, _from, next) => {
    const authStore = useAuthStore()

    if (to.meta.requiresAuth) {
        if (authStore.loading) {
            // potentially wait for init to finish here, simple implementation for now:
        }
        if (!authStore.user) {
            return next('/admin/login')
        }
        if (to.meta.requiresAdmin && !authStore.isAdmin) {
            return next('/')
        }
    }

    // redirect logged-in admins from login page
    if (to.path === '/admin/login' && authStore.user && authStore.isAdmin) {
        return next('/admin/dashboard')
    }

    next()
})

export default router
